import React, { useEffect, useRef } from "react";

const UnderlineSketch = ({ className = "w-full h-1", color = "black" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.beginPath();
    ctx.moveTo(0, canvas.height / 2);

    // Wellenförmig mit kleinen Asymmetrien
    ctx.bezierCurveTo(
      canvas.width * 0.2,
      canvas.height * 0.6,
      canvas.width * 0.4,
      canvas.height * 0.4,
      canvas.width * 0.6,
      canvas.height * 0.5
    );
    ctx.bezierCurveTo(
      canvas.width * 0.8,
      canvas.height * 0.7,
      canvas.width * 0.95,
      canvas.height * 0.3,
      canvas.width,
      canvas.height / 2
    );

    ctx.strokeStyle = color;
    ctx.lineWidth = 1.2;
    ctx.lineCap = "round";
    ctx.setLineDash([2, 0.3]); // ✍🏻 klassisch gezeichnet wirkend
    ctx.stroke();
  }, [color]);

  return <canvas ref={canvasRef} className={className} />;
};

export default UnderlineSketch;
